<div class="certificate-container">
    <div matTooltip="{{ certificationTooltip }}" [matTooltipPosition]="'above'"
        class="cert-image" [ngStyle]="{ 'background-image': 'url(' + certificationImageUrl + ')' }"
        [class]="full == true ? 'cert-image-full' : ''"></div>
    <p style="margin: auto" matTooltip="{{ certificationCountTooltip }}"
        [matTooltipPosition]="'below'">
        {{ this.certCount }}
    </p>
</div>